import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ThemeContext from '../../contexts/ThemeContext';
import GlobeIcon from '../../images/GlobeIcon';
import { FieldLabel, FieldValue } from './SummaryShared';
import i18n from '../../i18n';

const LanguageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const LanguageItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const LanguageValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const ArrowSeparator = styled.span`
  color: ${({ $colors }) => $colors.twilight};
  font-size: ${({ $layout }) => $layout.fontSize}px;
  margin-top: 16px;
`;

const SummaryLanguageRow = ({ fromLanguage, toLanguage }) => {
  const { colors, layout } = useContext(ThemeContext);

  return (
    <LanguageRow>
      <LanguageItem>
        <FieldLabel>{i18n('translation_from')}</FieldLabel>
        <LanguageValueRow>
          <GlobeIcon color={colors.iconAccentColor} size={16} />
          <FieldValue>{fromLanguage?.name || '-'}</FieldValue>
        </LanguageValueRow>
      </LanguageItem>
      <ArrowSeparator $colors={colors} $layout={layout}>&rarr;</ArrowSeparator>
      <LanguageItem>
        <FieldLabel>{i18n('translation_to')}</FieldLabel>
        <LanguageValueRow>
          <GlobeIcon color={colors.iconAccentColor} size={16} />
          <FieldValue>{toLanguage?.name || '-'}</FieldValue>
        </LanguageValueRow>
      </LanguageItem>
    </LanguageRow>
  );
};

SummaryLanguageRow.propTypes = {
  fromLanguage: PropTypes.object,
  toLanguage: PropTypes.object,
};

export default SummaryLanguageRow;
